<template>
  <div class="menu-nav">
    <router-link class="menu-nav__item" :to="route" v-slot="{ href, navigate, isActive }">
      <a :href="href" :class="{ '-active': isActive }" @click="navigate"> Otomatik Katılım </a>
    </router-link>
  </div>
</template>

<script>
export default {
  computed: {
    route: function () {
      let obj = {
        name: 'corporateHome',
        params: {
          contract: this.$route.params.contract ? this.$route.params.contract : null
        }
      }

      return obj
    }
  }
}
</script>